import { useState, useMemo } from "react";

const allCities = [
  { name: "Arvada", route: "/arvada", tagline: "Jefferson County expedited passport services", highlights: ["Arvada area coverage", "Serving Wheat Ridge, Westminster, Golden"], badge: null, status: "coming" },
  { name: "Aspen", route: "/aspen", tagline: "Pitkin County mountain town passport processing", highlights: ["Aspen area coverage", "Serving Snowmass Village, Basalt, Glenwood Springs"], badge: null, status: "coming" },
  { name: "Aurora", route: "/aurora", tagline: "Arapahoe County expedited passport hub", highlights: ["Aurora area coverage", "Serving Centennial, Parker, Denver metro"], badge: null, status: "coming" },
  { name: "Boulder", route: "/boulder", tagline: "Boulder County expedited passport services", highlights: ["Boulder area coverage", "Serving Longmont, Lafayette, Louisville, Nederland"], badge: null, status: "coming" },
  { name: "Breckenridge", route: "/breckenridge", tagline: "Summit County mountain resort passport processing", highlights: ["Breckenridge area coverage", "Serving Frisco, Silverthorne, Dillon"], badge: null, status: "coming" },
  { name: "Broomfield", route: "/broomfield", tagline: "Broomfield County expedited passport services", highlights: ["Broomfield area coverage", "Serving Westminster, Thornton, Lafayette"], badge: null, status: "coming" },
  { name: "Brighton", route: "/brighton", tagline: "Adams County expedited passport processing", highlights: ["Brighton area coverage", "Serving Commerce City, Fort Lupton, Henderson"], badge: null, status: "coming" },
  { name: "Castle Rock", route: "/castle-rock", tagline: "Douglas County expedited passport services", highlights: ["Castle Rock area coverage", "Serving Parker, Highlands Ranch, Lone Tree"], badge: null, status: "coming" },
  { name: "Centennial", route: "/centennial", tagline: "Arapahoe County expedited passport processing", highlights: ["Centennial area coverage", "Serving Littleton, Greenwood Village, Englewood"], badge: null, status: "coming" },
  { name: "Colorado Springs", route: "/colorado-springs", tagline: "El Paso County's premier expedited passport hub", highlights: ["Colorado Springs metro coverage", "Serving Manitou Springs, Fountain, Woodland Park"], badge: "Most Popular", status: "coming" },
  { name: "Commerce City", route: "/commerce-city", tagline: "Adams County expedited passport services", highlights: ["Commerce City area coverage", "Serving Brighton, Thornton, Denver"], badge: null, status: "coming" },
  { name: "Denver", route: "/denver", tagline: "Colorado's capital city expedited passport hub", highlights: ["Denver metro coverage", "Serving Aurora, Lakewood, Englewood, Centennial"], badge: "Most Popular", status: "coming" },
  { name: "Durango", route: "/durango", tagline: "La Plata County southwest Colorado passport services", highlights: ["Durango area coverage", "Serving Bayfield, Ignacio, Farmington NM area"], badge: null, status: "coming" },
  { name: "Englewood", route: "/cities/englewood", tagline: "Arapahoe County expedited passport processing", highlights: ["Englewood area coverage", "Serving Littleton, Sheridan, Greenwood Village"], badge: null, status: "coming" },
  { name: "Erie", route: "/cities/erie", tagline: "Weld & Boulder County expedited passport services", highlights: ["Erie area coverage", "Serving Lafayette, Broomfield, Longmont"], badge: null, status: "coming" },
  { name: "Fort Collins", route: "/fort-collins", tagline: "Larimer County northern Colorado passport hub", highlights: ["Fort Collins area coverage", "Serving Loveland, Windsor, Greeley"], badge: null, status: "coming" },
  { name: "Golden", route: "/golden", tagline: "Jefferson County expedited passport processing", highlights: ["Golden area coverage", "Serving Lakewood, Arvada, Evergreen"], badge: null, status: "coming" },
  { name: "Grand Junction", route: "/grand-junction", tagline: "Mesa County western Colorado passport services", highlights: ["Grand Junction area coverage", "Serving Fruita, Clifton, Palisade"], badge: null, status: "coming" },
  { name: "Greeley", route: "/greeley", tagline: "Weld County northern Colorado passport processing", highlights: ["Greeley area coverage", "Serving Evans, Windsor, Johnstown"], badge: null, status: "coming" },
  { name: "Highlands Ranch", route: "/highlands-ranch", tagline: "Douglas County south metro passport services", highlights: ["Highlands Ranch area", "Serving Littleton, Lone Tree, Castle Rock"], badge: null, status: "coming" },
  { name: "Lafayette", route: "/lafayette", tagline: "Boulder County expedited passport processing", highlights: ["Lafayette area coverage", "Serving Louisville, Broomfield, Erie"], badge: null, status: "coming" },
  { name: "Lakewood", route: "/lakewood", tagline: "Jefferson County expedited passport hub", highlights: ["Lakewood area coverage", "Serving Golden, Arvada, Littleton"], badge: null, status: "coming" },
  { name: "Littleton", route: "/littleton", tagline: "Arapahoe & Jefferson County passport processing", highlights: ["Littleton area coverage", "Serving Englewood, Highlands Ranch, Centennial"], badge: null, status: "coming" },
  { name: "Longmont", route: "/longmont", tagline: "Boulder & Weld County expedited passport services", highlights: ["Longmont area coverage", "Serving Boulder, Erie, Frederick"], badge: null, status: "coming" },
  { name: "Loveland", route: "/loveland", tagline: "Larimer County northern Colorado passport processing", highlights: ["Loveland area coverage", "Serving Fort Collins, Berthoud, Windsor"], badge: null, status: "coming" },
  { name: "Louisville", route: "/louisville-co", tagline: "Boulder County expedited passport services", highlights: ["Louisville area coverage", "Serving Lafayette, Boulder, Superior"], badge: null, status: "coming" },
  { name: "Northglenn", route: "/northglenn", tagline: "Adams & Weld County expedited passport processing", highlights: ["Northglenn area coverage", "Serving Thornton, Westminster, Broomfield"], badge: null, status: "coming" },
  { name: "Parker", route: "/parker", tagline: "Douglas County south metro passport services", highlights: ["Parker area coverage", "Serving Castle Rock, Lone Tree, Centennial"], badge: null, status: "coming" },
  { name: "Pueblo", route: "/pueblo", tagline: "Pueblo County southern Colorado passport processing", highlights: ["Pueblo area coverage", "Serving Colorado Springs south, Canon City"], badge: null, status: "coming" },
  { name: "Steamboat Springs", route: "/steamboat-springs", tagline: "Routt County mountain resort passport services", highlights: ["Steamboat Springs area", "Serving Craig, Hayden, Oak Creek"], badge: null, status: "coming" },
  { name: "Telluride", route: "/telluride", tagline: "San Miguel County mountain town passport processing", highlights: ["Telluride area coverage", "Serving Mountain Village, Ridgway, Ouray"], badge: null, status: "coming" },
  { name: "Thornton", route: "/thornton", tagline: "Adams & Weld County north metro passport services", highlights: ["Thornton area coverage", "Serving Westminster, Northglenn, Brighton"], badge: null, status: "coming" },
  { name: "Vail", route: "/vail", tagline: "Eagle County world-class resort passport processing", highlights: ["Vail area coverage", "Serving Avon, Edwards, Eagle, Minturn"], badge: null, status: "coming" },
  { name: "Westminster", route: "/westminster", tagline: "Adams & Jefferson County north metro passport hub", highlights: ["Westminster area coverage", "Serving Thornton, Arvada, Broomfield"], badge: null, status: "coming" },
  { name: "Wheat Ridge", route: "/wheat-ridge", tagline: "Jefferson County expedited passport processing", highlights: ["Wheat Ridge area coverage", "Serving Lakewood, Arvada, Golden"], badge: null, status: "coming" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function ColoradoCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Colorado Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Colorado Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Colorado</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Colorado locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}